export default "__VITE_ASSET__CQCS3HIc__"